(() => {
        if (window.__preaFloatingUiCoordinator) return;
        window.__preaFloatingUiCoordinator = true;

        const root = document.documentElement;
        const layerZIndex = 'var(--prea-floating-layer-z-index, 990)';
        const safeBottom = (px) => `calc(${Math.max(0, Math.round(px))}px + env(safe-area-inset-bottom, 0px))`;
        const chatSelectors = [
          '.chat-toggle[data-spec="toggle-button"]',
          '[data-spec="toggle-button"].chat-toggle',
          '.chat-app .chat-toggle',
          '#shopify-element-wrapper',
          '.activator-nudge',
          '#shopify-element-wrapper .activator-nudge',
          '#shopify-element-wrapper .activator',
          '#shopify-element-wrapper button[part~="activator"]',
          '#shopify-element-wrapper button[aria-label="Chat"]',
          '.activator-nudge .activator',
          'button.activator[part~="activator"]',
          '.activator[aria-label="Chat"]',
          '#dummy-chat-button-iframe',
          '#ShopifyChat',
          '#shopify-chat',
          '[id*="ShopifyChat"]',
          '[id*="shopify-chat" i]',
          '[id*="shopify-inbox" i]',
          '[class*="ShopifyChat"]',
          '[class*="shopify-chat" i]',
          '[class*="shopify-inbox" i]',
          'iframe[id^="dummy-chat"]',
          'shopify-inbox',
          'shopify-chat',
          'shopify-chat-widget',
          'shopify-inbox-widget',
          'shopify-agent',
          'shopify-agent-chat',
          'shopify-inbox-agent',
          'shopify-inbox-chat',
          'shopify-online-store-chat',
          'iframe[id*="shopify-chat" i]',
          'iframe[id*="shopify-inbox" i]',
          'iframe[class*="shopify-chat" i]',
          'iframe[class*="shopify-inbox" i]',
          'iframe[src*="shopify-chat" i]',
          'iframe[src*="shopifychat" i]',
          'iframe[src*="shopify-inbox" i]',
          'iframe[src*="shopifyinbox" i]',
          'iframe[src*="shopify_chat" i]',
          'iframe[src*="shopifycloud" i][src*="chat" i]',
          'iframe[src*="inbox.shopify" i]',
          'iframe[title*="chat" i]',
          'iframe[name*="chat" i]',
          'iframe[id*="chat" i]'
        ].join(',');
        const formSelectors = [
          'shopify-forms-embed',
          'shopify-forms-popup',
          'shopify-forms',
          '[data-shopify-forms]',
          '[data-shopify-form]',
          'iframe[id*="shopify-forms" i]',
          'iframe[class*="shopify-forms" i]',
          'iframe[src*="forms.shopify" i]',
          'iframe[src*="shopifyforms" i]',
          'iframe[title*="shopify forms" i]',
          'iframe[title*="form" i]',
          'iframe[name*="shopify-forms" i]',
          'iframe[name*="forms" i]',
          'div[id*="shopify-forms" i]',
          'div[class*="shopify-forms" i]',
          'div[id*="shopifyForms" i]',
          'div[class*="shopifyForms" i]',
          'div[id*="forms-app" i]',
          'div[class*="forms-app" i]'
        ].join(',');

        const getElements = (selector) => {
          const results = [];
          const seen = new Set();

          const pushMatches = (scope) => {
            if (!scope || !scope.querySelectorAll) return;

            try {
              scope.querySelectorAll(selector).forEach((element) => {
                if (seen.has(element)) return;
                seen.add(element);
                results.push(element);
              });
            } catch (error) {
              return;
            }

            try {
              scope.querySelectorAll('*').forEach((element) => {
                if (element.shadowRoot) pushMatches(element.shadowRoot);
              });
            } catch (error) {
              return;
            }
          };

          try {
            pushMatches(document);
            return results;
          } catch (error) {
            return [];
          }
        };

        const isVisible = (element) => {
          if (!element || element.hidden) return false;
          const style = window.getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          const rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
        };

        const parentElementOrHost = (element) => {
          if (!element) return null;
          if (element.parentElement) return element.parentElement;

          const rootNode = element.getRootNode ? element.getRootNode() : null;
          return rootNode && rootNode.host ? rootNode.host : null;
        };

        const fixedElementFor = (element) => {
          let current = element;

          while (current && current !== document.body && current !== document.documentElement) {
            if (window.getComputedStyle(current).position === 'fixed') return current;
            current = parentElementOrHost(current);
          }

          return null;
        };

        const fixedBottomFloating = (element, side) => {
          const fixedElement = fixedElementFor(element);
          if (!fixedElement || !isVisible(fixedElement)) return null;

          const rect = fixedElement.getBoundingClientRect();
          const inBottomZone = rect.top > window.innerHeight * 0.3;
          const notFullScreen = rect.width < window.innerWidth * 0.92 && rect.height < window.innerHeight * 0.82;
          const onRequestedSide =
            side === 'left'
              ? rect.left < window.innerWidth * 0.5
              : rect.right > window.innerWidth * 0.5;

          return inBottomZone && notFullScreen && onRequestedSide ? { element: fixedElement, rect } : null;
        };

        const bottomFloatingElement = (element, side, options = {}) => {
          if (!isVisible(element)) return null;

          const rect = element.getBoundingClientRect();
          const inBottomZone = rect.top > window.innerHeight * (options.zoneStart || 0.3);
          const maxWidthRatio = options.maxWidthRatio || 0.92;
          const maxHeightRatio = options.maxHeightRatio || 0.82;
          const notFullScreen = rect.width < window.innerWidth * maxWidthRatio && rect.height < window.innerHeight * maxHeightRatio;
          const onRequestedSide =
            side === 'left'
              ? rect.left < window.innerWidth * 0.5
              : rect.right > window.innerWidth * 0.5;

          return inBottomZone && notFullScreen && onRequestedSide ? { element, rect } : null;
        };

        const bottomFloatingFor = (element, side, options = {}) => {
          return fixedBottomFloating(element, side) || bottomFloatingElement(element, side, options);
        };

        const uniqueFloatingItems = (items) => {
          const seen = new Set();
          return items.filter((item) => {
            if (!item || seen.has(item.element)) return false;
            seen.add(item.element);
            return true;
          }).filter((item, index, items) => {
            return !items.some((other, otherIndex) => {
              return otherIndex !== index && other.element.contains(item.element);
            });
          });
        };

        const overlapsRect = (rect, obstacleRect) => {
          if (!rect || !obstacleRect) return false;
          return (
            rect.left < obstacleRect.right &&
            rect.right > obstacleRect.left &&
            rect.top < obstacleRect.bottom &&
            rect.bottom > obstacleRect.top
          );
        };

        const moveElementUp = (element, offsetPx, transformOrigin) => {
          if (!element) return;
          const offset = Math.max(0, Math.round(offsetPx));
          const originalTransform = element.dataset.preaFloatingOriginalTransform !== undefined
            ? element.dataset.preaFloatingOriginalTransform
            : window.getComputedStyle(element).transform;

          if (element.dataset.preaFloatingOriginalTransform === undefined) {
            element.dataset.preaFloatingOriginalTransform = originalTransform === 'none' ? '' : originalTransform;
          }

          element.style.setProperty('transform-origin', transformOrigin || 'right bottom', 'important');

          if (offset > 0) {
            element.style.setProperty(
              'transform',
              `${element.dataset.preaFloatingOriginalTransform} translateY(-${offset}px)`.trim(),
              'important'
            );
          } else if (element.dataset.preaFloatingOriginalTransform) {
            element.style.setProperty('transform', element.dataset.preaFloatingOriginalTransform, 'important');
          } else {
            element.style.removeProperty('transform');
          }
        };

        const moveBottom = (item, bottomPx, obstacleRect, gapPx) => {
          if (!item) return;
          item.element.style.setProperty('z-index', layerZIndex, 'important');
          item.element.style.setProperty('bottom', safeBottom(bottomPx), 'important');

          const rect = item.element.getBoundingClientRect();
          const lift = overlapsRect(rect, obstacleRect) ? rect.bottom - obstacleRect.top + Math.max(0, gapPx || 0) : 0;
          moveElementUp(item.element, lift, 'right bottom');
        };

        const resetFloatingStyles = (element) => {
          if (!element) return;
          element.style.removeProperty('bottom');
          element.style.removeProperty('transform');
          element.style.removeProperty('transform-origin');
          element.style.removeProperty('z-index');
          element.style.removeProperty('transition');
          delete element.dataset.preaFloatingOriginalTransform;
        };

        const resetFloatingTransform = (element) => {
          if (!element || element.dataset.preaFloatingOriginalTransform === undefined) return;

          if (element.dataset.preaFloatingOriginalTransform) {
            element.style.setProperty('transform', element.dataset.preaFloatingOriginalTransform, 'important');
          } else {
            element.style.removeProperty('transform');
          }
        };

        const moveFrameUp = (element, offsetPx) => {
          if (!element) return;
          element.style.setProperty('z-index', layerZIndex, 'important');
          moveElementUp(element, offsetPx, 'left bottom');
        };

        const moveFullScreenFormFrames = (offsetPx) => {
          getElements(formSelectors).forEach((element) => {
            if (!isVisible(element)) return;
            const style = window.getComputedStyle(element);
            if (style.position !== 'fixed') return;

            const rect = element.getBoundingClientRect();
            const tagName = element.tagName.toLowerCase();
            const frameLike =
              tagName === 'iframe' ||
              rect.width >= window.innerWidth * 0.9 ||
              rect.height >= window.innerHeight * 0.78;

            if (!frameLike) return;
            moveFrameUp(element, offsetPx);
          });
        };

        const setLayer = (element) => {
          if (!element) return;
          element.style.setProperty('z-index', layerZIndex, 'important');
        };

        let frame = 0;
        let wasStickyVisible = false;
        const update = () => {
          frame = 0;

          const width = window.innerWidth;
          const gap = width >= 750 ? 24 : 16;
          const defaultActionsBottom = width >= 1200 ? 102 : width >= 750 ? 108 : 116;
          const stickyATC = document.querySelector('[data-hc-sticky-atc]');
          const stickyVisible =
            stickyATC &&
            !stickyATC.hidden &&
            stickyATC.classList.contains('is-visible') &&
            isVisible(stickyATC);

          if (!stickyVisible) {
            root.style.removeProperty('--prea-floating-right-bottom');
            root.style.removeProperty('--prea-floating-left-bottom');
            root.style.removeProperty('--prea-floating-actions-bottom');

            if (wasStickyVisible) {
              getElements(chatSelectors).forEach(resetFloatingStyles);
              getElements(formSelectors).forEach(resetFloatingStyles);
            }
            wasStickyVisible = false;
            return;
          }

          wasStickyVisible = true;
          const chatElements = getElements(chatSelectors);
          const formElements = getElements(formSelectors);

          const stickyRect = stickyATC.getBoundingClientRect();
          const stickyHeight = Math.ceil(stickyRect.height);
          const stickyStack = Math.ceil(window.innerHeight - stickyRect.top);
          const clearance = stickyStack > 0 ? stickyStack + gap : gap;

          root.style.setProperty('--prea-floating-right-bottom', safeBottom(clearance));
          root.style.setProperty('--prea-floating-left-bottom', safeBottom(clearance));

          const chatItems = uniqueFloatingItems(
            chatElements
              .map((element) => bottomFloatingFor(element, 'right'))
              .filter(Boolean)
          );
          const chatLauncher = chatItems
            .slice()
            .sort((a, b) => (a.rect.width * a.rect.height) - (b.rect.width * b.rect.height))[0];
          const chatHeight = chatLauncher ? Math.min(Math.ceil(chatLauncher.rect.height), 80) : 64;
          const compactActionsBottom = clearance + Math.max(chatHeight, 56) + 8;
          const actionsBottom = width < 750
            ? compactActionsBottom
            : Math.max(defaultActionsBottom + stickyStack, clearance + chatHeight + gap);

          root.style.setProperty('--prea-floating-actions-bottom', safeBottom(actionsBottom));

          if (stickyATC) setLayer(stickyATC);
          const floatingActions = document.querySelector('.prea-floating-actions');
          if (floatingActions) setLayer(floatingActions);

          chatItems.forEach((item) => {
            if (width < 750) {
              resetFloatingTransform(item.element);
            }

            moveBottom(item, clearance, stickyRect, gap);
          });
          formElements
            .map((element) => bottomFloatingFor(element, 'left'))
            .filter(Boolean)
            .forEach((item) => moveBottom(item, clearance, stickyRect, gap));
          moveFullScreenFormFrames(stickyStack > 0 ? clearance : 0);
        };

        const schedule = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(update);
        };

        let armed = false;
        let observer = null;

        const armFloatingUi = () => {
          if (armed) return;
          if (!document.querySelector('[data-hc-sticky-atc]')) return;
          armed = true;

          window.removeEventListener('scroll', armFloatingUi);
          document.removeEventListener('pointerdown', armFloatingUi, true);
          window.addEventListener('resize', schedule, { passive: true });

          observer = new MutationObserver(schedule);
          if (document.body) {
            observer.observe(document.body, {
              attributes: true,
              childList: true,
              subtree: true,
              attributeFilter: ['class', 'hidden', 'style', 'open', 'aria-hidden']
            });
          }

          schedule();
        };

        window.__preaUpdateFloatingUi = () => {
          if (!armed) armFloatingUi();
          schedule();
        };

        const armFloatingUiOnIdle = () => {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(armFloatingUi, { timeout: 2600 });
          } else {
            window.setTimeout(armFloatingUi, 1600);
          }
        };

        window.addEventListener('scroll', armFloatingUi, { once: true, passive: true });
        document.addEventListener('pointerdown', armFloatingUi, { once: true, capture: true, passive: true });

        if (document.readyState === 'complete') {
          armFloatingUiOnIdle();
        } else {
          window.addEventListener('load', armFloatingUiOnIdle, { once: true });
        }
      })();

